// Common surveillance and LPR camera types based on market research
export const CAMERA_TYPES = [
  'Flock Safety LPR Camera (Video-enabled)',
  'Flock Safety Falcon Camera (Dual-lens PTZ)',
  'Flock Safety Condor Camera (Single-lens)',
  'Flock Safety Raven Camera (Mobile/Patrol)',
  'Axis P Series Camera (Fixed Professional)',
  'Axis Q Series Camera (Premium)',
  'Axis Q1809-LE (8K Bullet)',
  'Hikvision DeepinView (LPR)',
  'Hikvision DS-2CD862MF-E (Dome)',
  'Dahua WizMind Camera (AI LPR)',
  'Dahua IPC-HFW3841E-SA (Bullet)',
  'Verkada MV72 (Cloud Dome)',
  'Verkada LPR Camera (Dedicated)',
  'Generic LPR/ALPR Camera',
  'Generic Surveillance Camera',
  'PTZ (Pan-Tilt-Zoom) Camera',
  'Bullet Camera',
  'Dome Camera',
  'Traffic Camera',
  'Red Light Camera',
  'Speed Camera',
  'Other/Unknown Model'
];
